import { useSelector } from 'react-redux'
import { operationSlice } from '../app/reducers/operation'
import { useTranslation } from '../hooks/useTranslation'

export default function PaymentMethodSidebar({ methodsList, methodId, chooseMethod, resolution, collapsed, setCollapsed }) {
    const operation = useSelector(operationSlice.selectSlice);
    const { t } = useTranslation();
    return (
        <div className={"payment-choose-sidebar"}>
            <div className={"payment-choose-sidebar-title"}>{t('payment.select_method')}</div>
            {resolution === "xs" && (
                <div className={"payment-choose-btn payment-choose-hamburger" + (collapsed ? "" : " is-active")} role="button" tabIndex={0} aria-expanded={!collapsed} aria-label={t('payment.select_method')} onClick={() => { setCollapsed(!collapsed) }} onKeyDown={(e)=>{if(e.key==='Enter')setCollapsed(!collapsed)}}>
                    <span className={"sm-nav-payment-method-icon"} aria-hidden="true">
                        <span className={"hamburger-box"}>
                            <span className={"hamburger-inner"}></span>
                        </span>
                    </span>
                    <span className={"lbl-payment-method-name hamburger-label"}>{t('payment.select_method')}</span>
                </div>
            )}
            {methodsList.map((method, pos) => (
                <div key={method.id}
                    className={"payment-choose-btn choose-btn-" + (pos + 1) + (method.id === methodId ? " selected" : "")}
                    role="button" tabIndex={0}
                    onClick={() => chooseMethod(method, operation)}
                    onKeyDown={(e)=>{if(e.key==='Enter')chooseMethod(method, operation)}}>
                    <img src={method.small_icon_monochrome || method.small_icon} className={"sm-nav-payment-method-icon sm-nav-icon-mono"} />
                    <img src={method.small_icon} className={"sm-nav-payment-method-icon sm-nav-icon-color"} />
                    <span className={"lbl-payment-method-name"}>{'i18nKey' in method ? t(method.i18nKey) : method.name}</span>
                </div>
            ))}
        </div>
    )
}
